import React from "react";
import { EmptyTabletCol } from "../commons/Commons.style";
import { Col, Grid } from "../grid";
import {
  SectionBottomStyle,
  SectionContainerStyle,
} from "./SectionWrapper.style";

interface ISectionWrapperProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const SectionWrapper = ({ children, style }: ISectionWrapperProps) => {
  return (
    <SectionContainerStyle style={style}>
      {children}
      <Grid cols={12} columnGap={16} rowGap={0}>
        <EmptyTabletCol />
        <Col xxl={12} md={10} sm={12}>
          <SectionBottomStyle />
        </Col>
      </Grid>
    </SectionContainerStyle>
  );
};

export default SectionWrapper;
